import { render, staticRenderFns } from "./infotype.vue?vue&type=template&id=da451454"
import script from "./infotype.vue?vue&type=script&lang=js"
export * from "./infotype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports